import React, { useState, useEffect } from 'react';
import { Clock, Save } from 'lucide-react';
import { apiFetch } from '../utils/apiClient';
import { useNotification } from '../context/NotificationContext';

const Settings = () => {
  const { notifySuccess, notifyError, showLoading, hideLoading } = useNotification();
  const [overtimeRate, setOvertimeRate] = useState('');

  const fetchSettings = async () => {
    try {
      const response = await apiFetch('/api/settings');
      if (response.ok) {
        const data = await response.json();
        setOvertimeRate(data.overtime_rate_per_hour || '0');
      }
    } catch (e) {
      console.error('Error fetching settings');
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    showLoading('Saving settings…');
    try {
      const response = await apiFetch('/api/settings/overtime-rate', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rate: Number(overtimeRate) })
      });
      if (response.ok) {
        notifySuccess('Overtime rate updated');
      } else {
        const data = await response.json().catch(() => ({}));
        notifyError(data.error || 'Failed to update overtime rate');
      }
    } catch (e) {
      notifyError('Failed to update overtime rate');
    } finally {
      hideLoading();
    }
  };

  return (
    <div className="settings-page">
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700' }}>Settings</h1>
        <p style={{ color: 'var(--text-muted)' }}>Global payroll and attendance configuration</p>
      </div>

      <div className="card" style={{ maxWidth: '480px' }}>
        <h3 style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Clock size={18} />
          Overtime Rate
        </h3>
        <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '16px' }}>
          Applied automatically to every hour an employee checks out past their shift end. Same rate for all employees.
        </p>
        <form onSubmit={handleSave}>
          <label className="label">Overtime Rate (Rs per hour)</label>
          <input
            type="number"
            className="input-field"
            min="0"
            step="0.01"
            required
            value={overtimeRate}
            onChange={e => setOvertimeRate(e.target.value)}
          />
          <button type="submit" className="btn btn-primary" style={{ marginTop: '16px' }}>
            <Save size={16} style={{ marginRight: '8px' }} />
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default Settings;
